<template>
  <v-app id="nexus-enterprise-app">
    
    <LoadingCenter v-if="loadingDataInit || loadingInit" color="blue" />
   
    <EmpresaHeaderLayout :minimal="isMinimalHeader" />
    <AsistenteDrawer v-if="puedeUsarAsistente" />

    <v-main class="main-container-fix">
        <router-view  />
    </v-main>

    <v-overlay :value="loading" z-index="200">
      <v-progress-circular indeterminate size="64" color="blue"></v-progress-circular>
    </v-overlay>

  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import LoadingCenter from "@/util/LoadingCenter.vue";
import EmpresaHeaderLayout from "@/views/empresa/layout/EmpresaHeaderLayout.vue";
import AsistenteDrawer from "@/components/asistente/AsistenteDrawer.vue";

export default {
  name: "EmpresaLayout",
  components: {
    EmpresaHeaderLayout,
    AsistenteDrawer,
    LoadingCenter,
  },
  computed: {
    ...mapState(["loading", "loadingInit"]),
    ...mapState("initialData", ["loadingDataInit"]),
    ...mapState("notificaciones", ["alerta_retiro"]),
    ...mapGetters("notificaciones", ["bloqueoRetiroDinero"]),
    ...mapGetters("auth", ["puedeUsarAsistente", "rolPermiteAsistente"]),

    isMinimalHeader() {
      const routesSinHeader = ["empresa.comprasFacturaRegistrar"];
      return routesSinHeader.some(r => this.$route.name?.includes(r));
    },
  },
  methods: {
    ...mapActions(["fetchLinksPorMenu"]),
    ...mapActions("auth", ["fetchMisModulos"]),
    ...mapActions("asistente", ["cargarEstado"]),
    async inicializarMenu() {
      await this.fetchLinksPorMenu("administrador");
    },
  },
  watch: {
    alerta_retiro(val) {
      if (val) {
        if (this.bloqueoRetiroDinero) this.$router.push("/movimientos/retiro");
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "orange darken-4",
          text: `Aviso: Excedente en caja detectado.`,
          icon: "mdi-alert-octagon",
          timeout: -1,
          action: () => this.$router.push("/movimientos/retiro"),
        });
      }
    },
  },
  created() {
    this.inicializarMenu();
    this.fetchMisModulos();
    // El backend decide si esta empresa tiene el asistente; sin rol ni se pregunta
    if (this.rolPermiteAsistente) this.cargarEstado();
  },
};
</script>

<style scoped>
/* 1. Fondo Global: 
  Lo aplicamos a v-app para que no se mueva con el scroll del contenido.
*/
/* Mantené el fondo pero sacale el flex innecesario al main */
#nexus-enterprise-app {
  background-color: #0F0F0F !important;
  background-image: radial-gradient(circle at 50% -20%, #101010 0%, #0F0F0F 80%) !important;
  background-attachment: fixed;
  min-height: 100vh; /* Asegura que siempre cubra la pantalla */
}



/* Evitá el ::v-deep en el wrap a menos que tengas un problema de altura específico */
.main-container-fix ::v-deep .v-main__wrap {
  position: relative;
  /* Eliminamos el flex: 1 1 auto para dejar que el contenido fluya hacia abajo */
}
/* Transición de página suave */
.page-slide-enter-active, 
.page-slide-leave-active {
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.page-slide-enter {
  opacity: 0;
  transform: translateY(10px);
}
.page-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Scrollbars Estilizadas */
::v-deep .scroll-bar::-webkit-scrollbar,
::v-deep .overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}
::v-deep .scroll-bar::-webkit-scrollbar-track,
::v-deep .overflow-y-auto::-webkit-scrollbar-track {
  background: transparent;
}
::v-deep .scroll-bar::-webkit-scrollbar-thumb,
::v-deep .overflow-y-auto::-webkit-scrollbar-thumb {
  background: #1a1a1a;
  border-radius: 10px;
}
::v-deep .scroll-bar::-webkit-scrollbar-thumb:hover,
::v-deep .overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background: #2196f3;
}
</style>